import { useTranslation } from 'react-i18next';
import type { Option } from '#pie/components/input-radio/InputRadio';
import type { CreateSimpleDataRequest } from '#pie/internal/api/pie-bff';
import { Frequency } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormRadio } =
  typedFormFields<CreateSimpleDataRequest>();

export const SimpleFrequencyRequest = () => {
  //Welke specificaties/attributen wil je ontvangen?
  const { t } = useTranslation('dataRequest');
  const options: Option[] = [
    {
      label: t(`frequency_of_data_request.${Frequency.OneTime}`),
      value: Frequency.OneTime,
    },
    {
      label: t(`frequency_of_data_request.${Frequency.Weekly}`),
      value: Frequency.Weekly,
    },
    {
      label: t(`frequency_of_data_request.${Frequency.Monthly}`),
      value: Frequency.Monthly,
    },
    {
      label: t(`frequency_of_data_request.${Frequency.Quarterly}`),
      value: Frequency.Quarterly,
    },
    {
      label: t(`frequency_of_data_request.${Frequency.Yearly}`),
      value: Frequency.Yearly,
    },
  ];

  return (
    <ConditionalField
      field="frequency"
      condition={(fieldValue) =>
        !!fieldValue('periods') && fieldValue('periods')!.length > 0
      }
    >
      <FormRadio
        label={t('frequency')}
        options={options}
        name="frequency"
        rules={{ required: true }}
      />
    </ConditionalField>
  );
};
